import React from 'react';

import RequestMaterialModule from '../requestMaterial/components/RequestMaterialModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryRequestsModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.materialrequest', action: 'read' },
      ]}
    >
      <RequestMaterialModule />
    </InventoryPermissionGuard>
  );
}